module.exports = __webpack_public_path__ + "static/media/user-team.9c4f85b3.jpg";